module.exports = __webpack_public_path__ + "img/deal-ing.a63bc71e.png";